import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (leadId) => `${API_URL}/api/v1/event/${leadId}?includeData=1`;

const getLead = async (leadId) => await apiRequest(getUrl(leadId), "get");

export default getLead;
